import { render, staticRenderFns } from "./re-disbursement-lead.vue?vue&type=template&id=5c392832&"
import script from "./re-disbursement-lead.vue?vue&type=script&lang=js&"
export * from "./re-disbursement-lead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports